import { CRM_ACTIONS } from './typing';

export const MESSAGE_TYPE = 'CRM';

export const CRM_ACTIONS_MAP: { [key: string]: CRM_ACTIONS } = {
    [CRM_ACTIONS.GET_MATCHING_RECORDS]: CRM_ACTIONS.SET_MATCHING_RECORDS,
    [CRM_ACTIONS.GET_SEARCH_RECORD]: CRM_ACTIONS.SET_SEARCH_RECORD,
    [CRM_ACTIONS.GET_MATCHING_TICKETS]: CRM_ACTIONS.SET_MATCHING_TICKETS,
    [CRM_ACTIONS.CRM_CREATE_RECORD]: CRM_ACTIONS.CRM_CREATE_RECORD_RESULT,
    [CRM_ACTIONS.GET_CALL_LINK]: CRM_ACTIONS.SET_CALL_LINK,
    [CRM_ACTIONS.GET_CHAT_LINK]: CRM_ACTIONS.SET_CHAT_LINK,
    [CRM_ACTIONS.SUBMIT_LOG]: CRM_ACTIONS.SUBMIT_LOG_RESULT,
    [CRM_ACTIONS.START_RENDER]: CRM_ACTIONS.START_RENDER_RESULT,
};

export const ERROR_CODE_MAP = {
    COMMON: 10000,
    CALL_LOG_FAILED: 10001,
    DIGITAL_LOG_FAILED: 10002,
    CALL_NO_DISPOSITION: 10003,
    DIGITAL_NO_DISPOSITION: 10004,
    SCRIPT_TOKEN_INVALID: 10014,
    DIGITAL_TOKEN_INVALID: 10024,

    //SFDC Specific
    SF_SIDECAR_FAILED: 10005,

    //Zendesk Specific
    ZD_CREATE_USER_FAILED_FOR_DUPLICATE: 10006,
    ZD_CREATE_USER_FAILED_FOR_COMMON: 10007,
    ZD_CREATE_TICKET_FAILED_FOR_COMMON: 10013,
    // HubSpot Specific
    HS_CREATE_CONTACT_FAILED_FOR_DUPLICATE: 10008,
    HS_CREATE_CONTACT_FAILED_FOR_COMMON: 10009,

    ZH_API_RATE_LIMIT: 10010,
    ZH_REFRESH_TOKEN_FAILED: 10011,
    ZH_USER_REJECT_AUTH_ERROR: 10012,
};

export const RCX_BASE_URL = 'RCX_BASE_URL';
